import { BaseFetch } from "../main-model"
export default class SchoolBudgetModel extends BaseFetch {
    getSchoolBudgetBy = (data) =>
    this.authFetch({
      url: "school-budget/getSchoolBudgetBy",
      method: "POST",
      body: JSON.stringify(data),
    })
    getSchoolBudgetById = (data) =>
    this.authFetch({
      url: "school-budget/getSchoolBudgetById",
      method: "POST",
      body: JSON.stringify(data),
    })
    updateSchoolBudgetById = (data) =>
    this.authFetch({
      url: "school-budget/updateSchoolBudgetById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertSchoolBudget = (data) =>
    this.authFetch({
      url: "school-budget/insertSchoolBudget",
      method: "POST",
      body: JSON.stringify(data),
    })
    deleteSchoolBudgetById = (data) =>
    this.authFetch({
      url: "school-budget/deleteSchoolBudgetById",
      method: "POST",
      body: JSON.stringify(data),
    })
    getSchoolBudgetBySchoolAll = (data) =>
    this.authFetch({
      url: "school-budget/getSchoolBudgetBySchoolAll",
      method: "POST",
      body: JSON.stringify(data),
    })
}
